import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-59348411"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "fixed bottom-0 left-0 right-0 flex items-center justify-center p-4 bg-accent text-white"
};
const _hoisted_2 = { class: "relative w-full flex items-center justify-center" };
const _hoisted_3 = { class: "flex items-center" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "spinner mr-2 ml-2 pl-4" }, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.showBanner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("button", {
                    class: "absolute top-0 right-0 mt-2 mr-2 text-white text-2xl leading-none hover:text-opacity-70 focus:outline-none",
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.close && _ctx.close(...args)))
                }, " × "),
                _createElementVNode("div", _hoisted_3, [
                    _renderSlot(_ctx.$slots, "dynamic-content", {}, undefined, true),
                    (_ctx.showAnimation)
                        ? _renderSlot(_ctx.$slots, "spinner", { key: 0 }, () => [
                            _hoisted_4
                        ], true)
                        : _createCommentVNode("", true)
                ])
            ])
        ]))
        : _createCommentVNode("", true);
}
